// @flow
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import CloseIcon from "@material-ui/icons/Close";

import Display from "../component/Display";

const Transition = (props): React$Element<*> => (
  <Slide direction="down" {...props} />
);

type MobileDisplayStatesType = {
  open: boolean
};

class MobileDisplay extends React.Component<*, MobileDisplayStatesType> {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  render(): React$Element<*> {
    return (
      <span>
        <a onClick={this.handleClickOpen} className="scroll-btn">
          <span></span>
          <span></span>
          <span></span>
        </a>
        <Dialog
          fullScreen
          open={this.state.open}
          onClose={this.handleRequestClose}
          TransitionComponent={Transition}
        >
          <div className="mui-form">
            <CloseIcon onClick={this.handleRequestClose} className="light-icon medium-icon fixed-icon" />
            <Display handleRequestClose={this.handleRequestClose} />
          </div>
        </Dialog>
      </span>
    );
  }
}

export default MobileDisplay;


// WEBPACK FOOTER //
// ./src/conference/containers/MobileDisplay.js